import { Navigate } from 'react-router-dom';

import { FeatureHOC } from 'features';
import { Achievements } from 'pages/Achievements';
import { ApplicationManager, Applications } from 'pages/Applications';
import { Bookings } from 'pages/Bookings';
import { Cashback } from 'pages/Cashback';
import { Clients } from 'pages/Clients';
import { ClubReviews } from 'pages/ClubReviews';
import { Combo } from 'pages/Combo';
import { Combos } from 'pages/Combos';
import { Computers } from 'pages/Computers';
import { Dashboard } from 'pages/Dashboard';
import { Discounts } from 'pages/Discounts';
import { GameAccounts } from 'pages/GameAccounts';
import { GoodManager } from 'pages/GoodManager';
import { Goods } from 'pages/Goods';
import { HostsMap } from 'pages/HostsMap';
import { Logs } from 'pages/Logs';
import { Payments } from 'pages/Payments';
import { PromoCodes } from 'pages/PromoCodes';
import { Reports } from 'pages/Reports';
import { Service } from 'pages/Service';
import { Services } from 'pages/Services';
import { Settings } from 'pages/Settings';
import { Shop } from 'pages/Shop';
import { Tariff } from 'pages/Tariff';
import { Tariffs } from 'pages/Tariffs';
import { Worker } from 'pages/Worker';
import { Workers } from 'pages/Workers';
import { IRoute } from 'types';

import { Advertisement } from './pages/Advertisement';
import { News } from './pages/News';
import { NewsManager } from './pages/NewsManager';
import { PromoCampaignManager } from './pages/PromoCampaignManager';
import { PromoCodeManager } from './pages/PromoCodeManager';

export const ROUTES: IRoute[] = [
  { path: '/', component: <Dashboard /> },
  { path: '/computers', component: <Computers />, permission: 'host_browse' },
  { path: '/map', component: <HostsMap />, permission: 'host_browse' },
  { path: '/bookings', component: <Bookings />, permission: 'booking_manage' },
  { path: '/clients', component: <Clients />, permission: 'client_browse' },
  { path: '/logs', component: <Logs />, permission: 'event_browse' },
  {
    path: '/payments',
    component: <Payments />,
    permission: ['work_shift_active', 'payment_browse'],
  },
  { path: '/shop', component: <Shop />, permission: 'payment_create' },
  { path: '/tariffs', component: <Tariffs />, permission: 'shop_manage' },
  { path: '/tariffs/:id', component: <Tariff />, permission: 'shop_manage' },
  { path: '/workers', component: <Workers />, permission: 'worker_manage' },
  {
    path: '/workers/:uuid',
    component: <Worker />,
    permission: 'worker_manage',
  },
  { path: '/services', component: <Services />, permission: 'shop_manage' },
  { path: '/services/:id', component: <Service />, permission: 'shop_manage' },
  { path: '/goods', component: <Goods />, permission: 'shop_manage' },
  { path: '/goods/:id', component: <GoodManager />, permission: 'shop_manage' },
  { path: '/combos/:id', component: <Combo />, permission: 'shop_manage' },
  { path: '/combos', component: <Combos />, permission: 'shop_manage' },
  {
    path: '/discounts',
    component: (
      <FeatureHOC
        alias="discounts"
        strategy="replace"
        nameKey="nav.discounts"
        fullHeight
      >
        <Discounts />
      </FeatureHOC>
    ),
    permission: 'loyalty_program_manage',
  },
  {
    path: '/promo-codes',
    component: (
      <FeatureHOC
        alias="discounts"
        strategy="replace"
        nameKey="nav.promo"
        fullHeight
      >
        <PromoCodes />
      </FeatureHOC>
    ),
    permission: 'loyalty_program_manage',
  },
  {
    path: '/promo-code',
    component: (
      <FeatureHOC
        alias="discounts"
        strategy="replace"
        nameKey="nav.promo"
        fullHeight
      >
        <PromoCodeManager />
      </FeatureHOC>
    ),
    permission: 'loyalty_program_manage',
  },
  {
    path: '/promo-campaign',
    component: (
      <FeatureHOC
        alias="discounts"
        strategy="replace"
        nameKey="nav.promo"
        fullHeight
      >
        <PromoCampaignManager />
      </FeatureHOC>
    ),
    permission: 'loyalty_program_manage',
  },
  {
    path: '/promo-code/:id',
    component: (
      <FeatureHOC
        alias="discounts"
        strategy="replace"
        nameKey="nav.promo"
        fullHeight
      >
        <PromoCodeManager />
      </FeatureHOC>
    ),
    permission: 'loyalty_program_manage',
  },
  {
    path: '/promo-campaign/:id',
    component: (
      <FeatureHOC
        alias="discounts"
        strategy="replace"
        nameKey="nav.promo"
        fullHeight
      >
        <PromoCampaignManager />
      </FeatureHOC>
    ),
    permission: 'loyalty_program_manage',
  },
  {
    path: '/cashback',
    component: (
      <FeatureHOC
        alias="deposit_cashback"
        strategy="replace"
        nameKey="nav.cashback"
        fullHeight
      >
        <Cashback />
      </FeatureHOC>
    ),
    permission: 'loyalty_program_manage',
  },
  {
    path: '/achievements',
    component: (
      <FeatureHOC
        alias="achievements"
        strategy="replace"
        nameKey="nav.achievements"
        fullHeight
      >
        <Achievements />
      </FeatureHOC>
    ),
    permission: 'loyalty_program_manage',
  },
  {
    path: '/game-accounts',
    component: <GameAccounts />,
    permission: 'game_account_manage',
  },
  {
    path: '/applications',
    component: <Applications />,
    permission: 'shortcut_manage',
  },
  {
    path: '/news',
    component: <News />,
    permission: 'news_manage',
  },
  {
    path: '/news/:id',
    component: <NewsManager />,
    permission: 'news_manage',
  },
  {
    path: '/reviews',
    component: <ClubReviews />,
    permission: 'club_comments_browse',
  },
  {
    path: '/applications/manage',
    component: <ApplicationManager />,
    permission: 'shortcut_manage',
  },
  {
    path: '/reports',
    component: <Reports />,
    permission: 'reports_manage',
  },
  { path: '/settings', component: <Settings />, permission: 'setting_manage' },
  { path: '/advertisement', component: <Advertisement /> },
  { path: '*', component: <Navigate to="/" replace /> },
];
